/**
 * Product Component
 */

//jshint ignore:start
(function(itxApp) {

    'use strict';

    /**
     * Product Redirect Component
     * @type ItxProductRedirectCmpCtrl
     * @name productRedirectCtrl
     */
    var ItxProductRedirectCmp = {
        controller: ItxProductRedirectCmpCtrl,
        controllerAs: 'productRedirectCtrl',
        templateUrl: 'ItxProductRedirectCmp.html'
    };

    angular.module('itxApp.catalog').component('itxProductRedirect', ItxProductRedirectCmp);

    ItxProductRedirectCmpCtrl.$inject = ['$scope', 'ngDialog', 'DUTTI_CONS', 'Product'];

    function ItxProductRedirectCmpCtrl($scope, ngDialog, DUTTI_CONS, Product) {
        var _this = this;

        _this.$onInit = function () {
            _this.storeId = inditex.iStoreJSON.redirectToWorldWide;
        };

        _this.goBack = function () {
            if (ngDialog) {
                ngDialog.close();
            }
        };

        _this.goToInternationalPage = function () {
            let url;
            inditex.setLocalStorage('COUNTRY_ISO', inditex.iCountryCode);
            const product = new Product($scope.$parent.ngDialogData.product);
            const available = $scope.$parent.ngDialogData.isAvailable;
            const languageId = -1;
            if (available) {
                url = product.getUrlByStore(_this.storeId, languageId);
            } else {
                const langCode = DUTTI_CONS.i_languages[languageId].toLowerCase();
                url = inditex.encodeUrl({
                    action : 'ItxHomePage',
                    params : {
                        storeId: _this.storeId,
                        langId: languageId
                    },
                });
            }
            window.location.href = url;
        };

    }

})();